import React from 'react'
import { Display, ButtonsGroup, Button } from '@brainstud/react-helpers'
import styles from './TourWidget.module.css'

class TourBase extends React.Component {
  constructor(props) {
    super(props)

    this.image = new Image()
    this.image.onload = () => {
      this.setState({
        width: this.image.width,
        height: this.image.height,
        percent: this.image.height / this.image.width * 100,
      })
      this.hasLoaded()
    }
    this.image.src = this.props.image

    this.state = {
      width: null,
      height: null,
      percent: 0,
    }
  }

  componentWillUnmount() {
    this.image.onload = null
  }

  hasLoaded() {
    if(this.props.onLoad) {
      this.props.onLoad()
    }
  }

  render() {
    return (
      <div className={`tour-el ${styles.base}`} style={{ paddingBottom: `${this.state.percent}%` }}>
        {this.state.percent ? this.props.children(this.state) : null}
      </div>
    )
  }
}

export default TourBase
